import { BatteryWarningIcon, FileX2Icon, GavelIcon, WalletIcon } from 'lucide-react'
import type { LucideIcon } from 'lucide-react'

export interface PainPoint {
  id: string
  icon: LucideIcon
  kicker: string
  title: string
  stat: string
  statLabel: string
  body: string
  solution: string
}

export const painPoints: PainPoint[] = [
  {
    id: 'leyes',
    icon: GavelIcon,
    kicker: 'Sin saber las reglas, pagas caro',
    title: 'Ignorancia de las leyes',
    stat: 'USD 500 – 8,000',
    statLabel: 'en multas según el país',
    body: 'Sin conocer las regulaciones exactas de tu país, cometes un error legal en tu primer vuelo comercial no autorizado.',
    solution:
      'Drone Commander te enseña las leyes exactas de Argentina, Colombia, México, Chile y Perú desde la primera lectura.',
  },
  {
    id: 'equipo',
    icon: WalletIcon,
    kicker: 'Compras el dron equivocado',
    title: 'Pérdida de dinero en equipo',
    stat: 'USD 500 – 2,000',
    statLabel: 'gastados de más',
    body: 'Comprar un dron sin saber qué necesitas realmente es como comprar un auto sin saber para qué lo quieres. Muchos gastan en equipos que no sirven para lo que imaginaban.',
    solution:
      'El Tomo 3 te muestra exactamente qué equipo necesitas según tu meta: agronomía, fotografía, inspección, etc.',
  },
  {
    id: 'crashes',
    icon: BatteryWarningIcon,
    kicker: 'No entiendes cómo funciona',
    title: 'Crashes y pérdidas técnicas',
    stat: 'USD 5,000+',
    statLabel: 'en equipo perdido',
    body: 'No saber leer el clima, calibrar sensores o calcular autonomía real = dron perdido en el primer mes. Hemos visto pilotos perderlo todo por no entender la meteorología básica o el funcionamiento de la batería.',
    solution: 'Los Tomos 1 y 2 te enseñan la ciencia exacta que lo previene.',
  },
  {
    id: 'examen',
    icon: FileX2Icon,
    kicker: 'No apruebas el examen oficial',
    title: 'No poder certificarse',
    stat: '35 – 40%',
    statLabel: 'reprueba el primer intento',
    body: 'Sin preparación real para el examen oficial, perder 2 o 3 meses reprogramando fechas es costoso: tiempo más el dinero de cada reintento.',
    solution: 'El Tomo 4 es un simulacro completo del examen real. Pasarás a la primera.',
  },
]
